import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AI = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.7592 12.9467H12.5162C13.2227 12.9467 13.8335 12.4537 13.9824 11.763L15.6226 4.15956C15.8242 3.22514 15.112 2.3431 14.1561 2.34326L7.72332 2.34434C7.32719 2.3444 6.94717 2.50116 6.6662 2.7804L3.1439 6.28097C3.0546 6.36972 2.97682 6.46937 2.91241 6.57755L0.470332 10.6794C-0.124954 11.6792 0.595538 12.9467 1.7592 12.9467Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.94242 11.772H12.8656L14.6468 3.51758H12.6348L10.9661 11.2512L10.3114 3.51758H7.72566L3.53903 11.772H5.79337L6.47728 10.2879H8.9026L8.94242 11.772ZM8.78195 5.11889H8.80186H8.80303C8.79366 6.02286 8.80303 6.99699 8.83347 7.90096L8.85338 8.46897H7.31341L7.57456 7.90096C7.99732 6.99699 8.40954 6.02286 8.78195 5.11889Z"
        fill="white"
      />
    </svg>
  )
})

export default AI
